import { dbuiV1TransformStatusOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';

export const useGetTransformStatus = (id: string = '') => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();

  return useQuery({
    ...dbuiV1TransformStatusOptions({
      ...defaultOptions(),
      path: { workspace, id },
      query: { warehouse: selectedWarehouse!.id },
    }),
    enabled: !!workspace && !!selectedWarehouse && !!id,
    refetchInterval: (query) => {
      if (query.state.error) {
        return false;
      }

      if (query.state.data?.status === 'running') {
        return 1000;
      }
      return false;
    },
  });
};
